import React from 'react';
import logo from '../../img/logo.png';

function LiveFooter() {
  return (
    <footer className="w-full pt-8 pb-20 z-10">
      <div className="flex flex-col items-center justify-center px-6 space-y-4">
        <a href="/"><img src={logo} alt="Logo" className='h-8' /></a>
        <p className='text-sm text-center'>Easy Wedding Invitation Creator With RSVP</p>
      </div>
    </footer>
  );
}

export default LiveFooter;